export const uiTrelloCard = {
    name: 'UI Trello Card',
    description: '',
    displayField: 'name',
    fields: {
        name: {
            name: 'Name',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        image: {
            name: 'Image',
            type: 'Link',
            linkType: 'Asset',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkMimetypeGroup: ['image'] }]
        },
        label: {
            name: 'Label',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['red', 'purple', 'blue'] }]
        },
        users: {
            name: 'Users',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [
                    { linkMimetypeGroup: ['image'] },
                    {
                        assetImageDimensions: {
                            width: { min: 96, max: 96 },
                            height: { min: 96, max: 96 }
                        }
                    }
                ],
                linkType: 'Asset'
            }
        },
        hasDescription: {
            name: 'Has Description',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        descriptionType: {
            name: 'Description Type',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    in: [
                        'Text',
                        'Timer',
                        'CheckList',
                        'CheckListInProgress',
                        'CheckListDone'
                    ]
                }
            ]
        }
    }
};
//# sourceMappingURL=uiTrelloCard.js.map